var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 202,
    viewBox: "0 0 338 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9685 3.75977H0V198.467H25.9685V3.75977Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.642 127.439H109.271C81.6502 127.439 59.1836 105.062 59.1836 77.5506V3.69934H136.028C163.649 3.69934 186.115 26.0767 186.115 53.5878V72.9H160.147V53.5878C160.147 40.3456 149.323 29.5646 136.028 29.5646H85.1521V77.5506C85.1521 90.7928 95.9761 101.574 109.271 101.574H122.642V127.439ZM188.708 148.412V125.174C188.708 97.663 166.241 75.2857 138.62 75.2857H122.642V101.151H138.62C151.915 101.151 162.739 111.932 162.739 125.174V148.412C162.739 161.654 151.915 172.435 138.62 172.435H85.1521V129.13H59.1836V198.301H138.62C166.241 198.301 188.708 175.923 188.708 148.412Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.148 202H272.827C239.279 202 211.977 174.806 211.977 141.391V60.594C211.977 27.179 239.279 -0.0150146 272.827 -0.0150146H277.148C310.696 -0.0150146 337.999 27.179 337.999 60.594H312.03C312.03 41.448 296.386 25.8654 277.163 25.8654H272.843C253.62 25.8654 237.975 41.448 237.975 60.594V141.391C237.975 160.537 253.62 176.12 272.843 176.12H277.163C296.386 176.12 312.03 160.537 312.03 141.391H337.999C337.999 174.806 310.696 202 277.148 202Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbcLogo);
export default __webpack_public_path__ + "static/media/ibc-logo.4ad323b063b0217ee076f16b6cae3bce.svg";
export { ForwardRef as ReactComponent };